import { sv } from "@dhx/ts-common/dom";

export const shadow = () =>
	sv("filter", { id: "shadow" }, [
		sv(
			"feDiffuseLighting",
			{
				in: "SourceGraphic",
				result: "light",
				"lighting-color": "white",
			},
			[sv("feDistantLight", { azimuth: 90, elevation: 25 })]
		),
		sv("feComposite", {
			in: "SourceGraphic",
			in2: "light",
			operator: "arithmetic",
			k1: "1",
			k2: "0",
			k3: "0",
			k4: "0",
		}),
	]);

export const dropShadow = () =>
	sv(
		"filter",
		{
			id: "dropshadow",
			x: "-100%",
			y: "-100%",
			width: "300%",
			height: "300%",
		},
		[
			sv("feGaussianBlur", { in: "SourceAlpha", stdDeviation: 2 }),
			sv("feOffset", { dx: 0, dy: 0, result: "offsetblur" }),
			sv("feOffset", { dx: 0, dy: 0, result: "offsetblur" }),
			sv("feFlood", { "flood-color": "rgba(85,85,85,0.5)" }),
			sv("feComposite", { in2: "offsetblur", operator: "in" }),
			sv("feMerge", [sv("feMergeNode"), sv("feMergeNode", { in: "SourceGraphic" })]),
		]
	);
